import styled from 'styled-components';
import { safeGap } from '../../../../styles/mixins';
import { primaryButton } from '../../../../styles/buttons';

export const ModalButtons = styled.div`
  display: flex;
  justify-content: space-between;
  ${safeGap('16px')};

  @media (max-width: 767px) {
    gap: 16px;
    flex-direction: column-reverse;
  }
`;

export const ModalPrimaryButton = styled.button`
  ${primaryButton};
  flex-grow: 1;
`;

export const ModalImage = styled.img`
  max-width: 166px;
  margin-bottom: 16px;
`;

export const ModalTitle = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;

export const ModalBody = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  .chat-gpt-disclaimer-modal & {
    p {
      margin-bottom: 16px;
    }
    a {
      text-decoration: underline;
      font-weight: bold;
    }
  }
`;
